export function convertRemToPixels(rem: string) {
  rem = rem.replace("rem", "");
  return (
    parseFloat(rem) * parseFloat(getComputedStyle(document.documentElement).fontSize)
  );
}
